import React from "react";
var __jsx = React.createElement;
import providerManager from "@lib/data/managers/shared/provider-manager";
import { useState } from "react";
import useErrorsManagement from "./use-errors-management";
import { useCustomer } from "@lib/context/shared/customer-context";
import { useModalMessages } from "@lib/context/shared/modal-message-context";
import { useTranslations } from "next-intl";
import { useActiveContent } from "@lib/context/shared/active-content-context";
import MuscleBenefitRegistrationScreen from "@modules/shared/screen-templates/benefit-registration-screen";
import MuscleBenefitPlatformLayout from "@modules/layout/benefit";
import { useNotifications } from "@lib/context/shared/notifications-context";
import { NotificationType } from "types/shared/notification-types";
import { trackMetaPixelEvent } from "@lib/util/meta-pixel";
import useMuscleRouter from "./use-muscle-router";
import { DEFAULT_APP } from "@lib/constants";
import { encodeObjectToQueryString } from "@lib/util/object-ops";
import { MIXPANEL_EVENTS } from "@lib/mixpanel/mixpanel.event-list";
import useTrackEvent from "./use-track-event";
import customersManager from "@lib/data/managers/shared/customers-manager";
import { permissionsManager } from "@lib/permissions/permissions-manager";
const useBenefitAuth = () => {
  const {
    0: iframeOpen,
    1: setIframeOpen
  } = useState(false);
  const {
    0: iframeUrl,
    1: setIframeUrl
  } = useState();
  const {
    0: loadingProviderValidation,
    1: setLoadingProviderValidation
  } = useState(false);
  const {
    0: token,
    1: setToken
  } = useState();
  const {
    setAuthenticatedCustomer,
    setCustomerIsValidated,
    setIsSessionProviderActive,
    getLoggedCustomer,
    checkActiveProviderSession
  } = useCustomer();
  const {
    manageSharedError
  } = useErrorsManagement();
  const {
    showModalMessage
  } = useModalMessages();
  const t = useTranslations("Shared");
  const {
    changeActiveContent,
    setActiveContentToDefault
  } = useActiveContent();
  const {
    notify
  } = useNotifications();
  const router = useMuscleRouter();
  const trackEvent = useTrackEvent();
  const withoutEntityLogin = !permissionsManager.useEntityLogin();
  const openBenefitLogin = async () => {
    const tokenPromise = providerManager.getProviderToken();
    const tokenResponse = await tokenPromise;
    if (tokenResponse.access_token) {
      setIframeUrl(getIframeUrl(tokenResponse.access_token));
      setIframeOpen(true);
    } else {
      manageSharedError(tokenResponse);
    }
  };
  const openBenefitRegister = async () => {
    const tokenPromise = providerManager.getProviderRegisterToken();
    const tokenResponse = await tokenPromise;
    if (tokenResponse.access_token) {
      // setIframeUrl(getIframeUrl(tokenResponse.access_token))
      // setIframeOpen(true)
      setToken(tokenResponse.access_token);
    } else {
      manageSharedError(tokenResponse);
    }
  };
  const getIframeUrl = token => {
    let url = "".concat(process.env.NEXT_PUBLIC_EXTERNAL_LOGIN_IFRAME_URL, "?client_id=").concat(process.env.NEXT_PUBLIC_EXTERNAL_LOGIN_CLIEND_ID, "&redirect_uri=").concat(process.env.NEXT_PUBLIC_EXTERNAL_LOGIN_REDIRECT_URI, "&response_mode=web_message&scope=login&token=").concat(token);
    return url;
  };
  const validateProviderLogin = async (code, userId, fromExpiredSession) => {
    setLoadingProviderValidation(true);
    let responsePromise = Promise.resolve(null);
    try {
      responsePromise = customersManager.callbackProvider(code, userId);
      const response = await responsePromise;
      if (!(response !== null && response !== void 0 && response.code) && response !== null && response !== void 0 && response.access_token) {
        await handleSuccessfulLogin(response, fromExpiredSession);
        setIframeOpen(false);
        trackEvent(MIXPANEL_EVENTS.Profile.LOGIN, {
          Name: userId,
          Email: userId
        });
      } else {
        trackEvent(MIXPANEL_EVENTS.Profile.LOGIN_ERROR, {
          Name: userId,
          Email: userId,
          error: response === null || response === void 0 ? void 0 : response.message
        });
        handleLoginError(response, userId);
      }
    } catch (error) {
      handleLoginError(error, userId);
      trackEvent(MIXPANEL_EVENTS.Profile.LOGIN_ERROR, {
        Name: userId,
        Email: userId,
        error: error
      });
    } finally {
      setLoadingProviderValidation(false);
    }
  };
  const handleSuccessfulLogin = async (response, fromExpiredSession) => {
    const redirectToFlowInitialPage = await setAuthenticatedCustomer(true, response);
    setCustomerIsValidated(true);
    trackMetaPixelEvent('Contact');
    setIsSessionProviderActive(true);
    const lastDataSearch = localStorage.getItem('lastSearch');
    if (lastDataSearch && !withoutEntityLogin) {
      handleSearchRedirection(lastDataSearch, fromExpiredSession, redirectToFlowInitialPage);
    }
  };
  const handleSearchRedirection = (lastDataSearch, fromExpiredSession, isBackendRequestingToRedirect) => {
    var _localStorage$getItem, _getLoggedCustomer, _getLoggedCustomer2, _window;
    let lastUserSearch;
    try {
      lastUserSearch = JSON.parse(lastDataSearch);
    } catch (error) {
      console.error('Invalid search data:', error);
      return;
    }
    const actualApp = (_localStorage$getItem = localStorage.getItem('current-app')) !== null && _localStorage$getItem !== void 0 ? _localStorage$getItem : DEFAULT_APP;
    trackEvent(MIXPANEL_EVENTS.Profile.REDIRECT_LAST_SEARCH, {
      Name: (_getLoggedCustomer = getLoggedCustomer()) === null || _getLoggedCustomer === void 0 ? void 0 : _getLoggedCustomer.first_name,
      Email: (_getLoggedCustomer2 = getLoggedCustomer()) === null || _getLoggedCustomer2 === void 0 ? void 0 : _getLoggedCustomer2.email,
      app: actualApp
    });
    if (fromExpiredSession && lastUserSearch) {
      switch (actualApp) {
        case 'hotels':
          const pathWindow = (_window = window) === null || _window === void 0 || (_window = _window.location) === null || _window === void 0 ? void 0 : _window.pathname;
          if (!pathWindow.includes('/details')) {
            router.push('/hotels/search', {
              search: encodeObjectToQueryString(lastUserSearch)
            });
          }
          break;
        case 'flights':
          if (isBackendRequestingToRedirect) {
            router.push('/flights/select', {
              search: encodeObjectToQueryString(lastUserSearch)
            });
          }
          break;
        case 'cars':
          router.push('/cars/search', {
            search: encodeObjectToQueryString(lastUserSearch)
          });
          break;
        default:
          break;
      }
    }
  };
  const showAuthErrorModal = () => {
    showModalMessage({
      title: t('Auth.ERROR_AUTH.ERROR_TITLE'),
      message: t('Auth.ERROR_AUTH.ERROR_MESSAGE'),
      closeable: true,
      actions: [{
        text: t('CONTINUE'),
        onClick: () => {}
      }]
    });
  };
  const handleLoginError = (error, userId) => {
    if ((error === null || error === void 0 ? void 0 : error.code) === 'user_not_registered') {
      setIframeOpen(false);
      if (permissionsManager.showRegisterForm()) {
        promptUserRegistration(userId);
      } else {
        setIframeOpen(false);
        manageSharedError(error);
      }
    } else {
      setIframeOpen(false);
      manageSharedError(error);
    }
  };
  const promptUserRegistration = userId => {
    setIframeOpen(false);
    changeActiveContent(__jsx(MuscleBenefitPlatformLayout, {
      headerProps: {
        hideContent: true,
        onClickLogo: () => {
          setActiveContentToDefault();
        }
      }
    }, __jsx(MuscleBenefitRegistrationScreen, {
      title: t('Auth.CREATE_AN_ACCOUNT'),
      description: t('Auth.CREATE_AN_ACCOUNT_DESCRIPTION'),
      buttonText: t('Auth.REGISTER'),
      customerId: userId,
      onSubmit: registerNewCustomer,
      isSubmitting: false
    })));
  };
  const registerNewCustomer = async info => {
    try {
      var _response$data, _response$data2, _response$data3;
      const response = await customersManager.registerProviderCustomer({
        email: info.email,
        email_confirmation: info.email,
        identification_type: 1,
        identification_number: info.identification_number,
        first_name: info.first_name,
        last_name: info.last_name,
        bank_uniq_id: info.userId,
        oauth_provider: 'benefit',
        oauth_uid: info.userId,
        country: info.country
      });
      if (response.error) {
        notify(response.message, NotificationType.ERROR);
        trackEvent(MIXPANEL_EVENTS.Profile.NEW_USER_REGISTRATION_ERROR, {
          error: response.message
        });
        return;
      }
      setAuthenticatedCustomer(true, response);
      setCustomerIsValidated(true);
      trackMetaPixelEvent('CompleteRegistration');
      checkActiveProviderSession();
      trackEvent(MIXPANEL_EVENTS.Profile.NEW_USER_REGISTRATION, {
        Name: ((_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.first_name) + ' ' + ((_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.last_name),
        Email: (_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : _response$data3.email
      }, response.data);
      setActiveContentToDefault();
    } catch {
      showAuthErrorModal();
    }
  };
  return {
    validateProviderLogin,
    openBenefitLogin,
    openBenefitRegister,
    loadingProviderValidation,
    iframeOpen,
    setIframeOpen,
    iframeUrl,
    token
  };
};
export default useBenefitAuth;